import { render, staticRenderFns } from "./Block3Others.vue?vue&type=template&id=a44dde8e"
import script from "./Block3Others.vue?vue&type=script&lang=ts"
export * from "./Block3Others.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports